import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  settings: {},
  settingsLoader: false,
  updateSettingsDetails: {},
  updateSettingsLoader: false,
  scansData: {},
  scansLoader: false,
  scheduledData: {},
  scheduledLoader: false,
  startScanDetails: {},
  startScanLoader: false,
  startScanError: null,
  updateScheduledDetails: {},
  updateScheduledLoader: false,
  deleteScheduledDetails: {},
  deleteScheduledLoader: false,
  scheduledScanError: null,
  settingsSaveError: null,
  scanInsights: {},
  scanInsightsLoader: false,
  acknowledgeInsightsDetails: {},
  acknowledgeInsightsLoader: false,
};

const scans = createSlice({
  name: "scans",
  initialState,
  reducers: {
    getScanSettings(state) {
      state.settingsLoader = true;
    },
    fetchScanSettings(state, action) {
      state.settings = action.payload;
      state.settingsLoader = false;
    },
    updateScanSettings(state) {
      state.updateSettingsDetails = {};
      state.updateSettingsLoader = true;
      state.startScanError = null;
      state.settingsSaveError = null;
    },
    fetchUpdateScanSettings(state, action) {
      state.updateSettingsDetails = action.payload;
      if (action.payload?.success) {
        state.settings = {
          success: true,
          data: action.payload.data,
        };
      }
      state.updateSettingsLoader = false;
      state.settingsSaveError = action.payload?.success
        ? null
        : action.payload?.message ||
          action.payload?.data?.message ||
          "Unable to save scan settings.";
    },
    getScansData(state, action) {
      if (!action.payload?.silent) {
        state.scansLoader = true;
      }
    },
    fetchScansData(state, action) {
      const payload = action.payload;
      if (payload?.success || !state.scansData?.success) {
        state.scansData = payload;
      }
      state.scansLoader = false;
    },
    getScheduledScansData(state, action) {
      if (!action.payload?.silent) {
        state.scheduledLoader = true;
      }
    },
    fetchScheduledScansData(state, action) {
      state.scheduledData = action.payload;
      state.scheduledLoader = false;
    },
    startScan(state) {
      state.startScanDetails = {};
      state.startScanLoader = true;
      state.startScanError = null;
    },
    fetchStartScan(state, action) {
      state.startScanDetails = action.payload;
      state.startScanLoader = false;
      if (!action.payload?.success) {
        state.startScanError =
          action.payload?.data?.message ||
          action.payload?.message ||
          action.payload?.error ||
          "Unable to start scan.";
      }
    },
    clearStartScanError(state) {
      state.startScanError = null;
    },
    clearSettingsSaveError(state) {
      state.settingsSaveError = null;
    },
    updateScheduledScan(state) {
      state.updateScheduledDetails = {};
      state.updateScheduledLoader = true;
      state.scheduledScanError = null;
    },
    fetchUpdateScheduledScan(state, action) {
      state.updateScheduledDetails = action.payload;
      state.updateScheduledLoader = false;
      if (!action.payload?.success) {
        state.scheduledScanError =
          action.payload?.data?.message ||
          action.payload?.message ||
          action.payload?.error ||
          "Unable to update scheduled scan.";
      }
    },
    deleteScheduledScan(state) {
      state.deleteScheduledDetails = {};
      state.deleteScheduledLoader = true;
      state.scheduledScanError = null;
    },
    fetchDeleteScheduledScan(state, action) {
      state.deleteScheduledDetails = action.payload;
      state.deleteScheduledLoader = false;
      if (!action.payload?.success) {
        state.scheduledScanError =
          action.payload?.data?.message ||
          action.payload?.message ||
          action.payload?.error ||
          "Unable to delete scheduled scan.";
      }
    },
    clearScheduledScanError(state) {
      state.scheduledScanError = null;
    },
    clearScansData(state) {
      Object.assign(state, initialState);
    },
    getScanInsights(state) {
      state.scanInsightsLoader = true;
    },
    fetchScanInsights(state, action) {
      state.scanInsights = action.payload;
      state.scanInsightsLoader = false;
    },
    acknowledgeScanInsights(state) {
      state.acknowledgeInsightsDetails = {};
      state.acknowledgeInsightsLoader = true;
    },
    fetchAcknowledgeScanInsights(state, action) {
      state.acknowledgeInsightsDetails = action.payload;
      state.acknowledgeInsightsLoader = false;
      if (action.payload?.success) {
        state.scanInsights = {
          success: true,
          data: {
            count: 0,
            items: [],
          },
        };
      }
    },
  },
});

export const scansAction = scans.actions;
export default scans.reducer;
